import { h } from 'preact'
import classNames from 'clsx'

import styles from './index.module.scss'

const Blockquote = ({ children, cite, className, ...rest }) => (
  <blockquote className={classNames(styles['a-blockquote'], className)} {...rest}>
    {children}
    {cite ? (<cite>{cite}</cite>) : null}
  </blockquote>
)

export default Blockquote
